<template lang="pug">
div
    el-dialog.resultado-diagnostico(
        :visible.sync='mostrarDialogCamadas',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        fullscreen
    )
        .lista
            .lista__header
                h2.cursor-pointer(@click='mostrarDialogCamadas = false')
                    i.el-icon-arrow-left.voltar
                    | Análise selecionada
            .lista__content
                .lista__grupo(
                    v-for='(grupo, index) in diagnosticoSelecionado.grupo'
                )
                    label.font-weight-bold {{ grupo.titulo }}
                    div
                        span {{ grupo.nome }}
                    DiagnosticoSocioambiental(
                        :dadosConsulta='grupo',
                        :indexCollapse='index',
                        :cpfCnpj='grupo.documento',
                        :habilitar-sinal-aviso='grupo.territorioProximidade',
                        :habilitar-inibicao-camada='habilitarInibicaoCamada',
                        @index-aberto='atualizarRestricaoMapa',
                        @inibir-restricao='abrirModalInibirRestricao'
                    )
        .mapa
            mapa(
                :showStatesLayers='false',
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :height='"100%"',
                :idMapa='"mapaAnaliseSocioambientalOperacao"',
                ref='mapa',
                :atualizarMapa='true',
                :menuMaior='true',
                :doubleMapOnPage='true'
            )

    ModalInibirRestricoes(
        ref='modalInibirRestricao',
        :id-operacao='inibicao.idOperacao',
        :codigo-restricao='inibicao.idRestricao',
        :codigo-camada='inibicao.codigoCamada',
        @atualizar-restricao-inibido='atualizarRestricaoInibido'
    )
    ModalJustificativaRestricoes(
        ref='modalJustificativaRestricao',
        :id-operacao='inibicao.idOperacao',
        :codigo-restricao='inibicao.idRestricao'
    )
</template>

<script>
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import Mapa from '@/components/MapaLeaflet.vue';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos.js';
import ModalInibirRestricoes from '@/components/operacao/gestao/ModalInibirRestricoes.vue';
import ModalJustificativaRestricoes from '@/components/operacao/gestao/ModalJustificativaRestricoes.vue';

export default {
    name: 'ModalResultadoDiagnostico',
    components: {
        ModalInibirRestricoes,
        ModalJustificativaRestricoes,
        Mapa,
        DiagnosticoSocioambiental
    },
    emits: ['atualizarDadosMonitoramento'],
    props: {
        habilitarInibicaoCamada: {
            default: false,
            required: false
        }
    },

    data() {
        return {
            restricao: null,
            inibicao: {
                idOperacao: '',
                idRestricao: '',
                codigoCamada: ''
            },
            mostrarDialogCamadas: false,
            mostrarDialogInibirRestricao: false,
            areasRestricao: [],
            diagnosticoSelecionado: [],
            collapsesAbertos: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true,
                    buscarCarControl: true,
                    bufferControl: false,
                    uploadFileControl: false,
                    ferramentasControl: false
                },
                historicoMonitoramento: false,
                inspecionar: true,
                diagnostico: false
            }
        };
    },

    methods: {
        atualizarRestricaoInibido() {
            this.restricao.inibido = true;
            this.diagnosticoSelecionado.grupo.forEach(grupo => {
                grupo.diagnostico.forEach(camada => {
                    camada.resultados
                        .filter(resultado => resultado.id === this.restricao.id)
                        .forEach(camadaIgual => {
                            camadaIgual.inibido = true;
                        });
                });
            });
            this.$emit('atualizarDadosMonitoramento');
        },
        atualizarRestricaoMapa(restricao, indexGrupo, indexCamada) {
            this.areasRestricao = [];

            /**
             * Remove o último quando for dentro do mesmo collapse
             */
            const mesmogGrupo = this.collapsesAbertos.find(
                c => c.indexGrupo === indexGrupo
            );
            if (mesmogGrupo) {
                this.layersMaps = this.layersMaps.filter(
                    l => l.tagRestricao !== mesmogGrupo.tag
                );
                this.collapsesAbertos = this.collapsesAbertos.filter(
                    l => l.tag !== mesmogGrupo.tag
                );
            }

            /**
             * Quando possuir indexCamada é por que o collapse está sendo aberto
             * Nesse caso a geometria é adicionada no mapa
             */
            if (indexCamada !== '') {
                const grupoSelecionado =
                    this.diagnosticoSelecionado.grupo[indexGrupo];
                const diagnosticoSelecionado =
                    grupoSelecionado.diagnosticos ||
                    grupoSelecionado.diagnostico;
                this.areasRestricao = diagnosticoSelecionado[
                    indexCamada
                ].resultados.filter(
                    resultado => resultado.geometria || resultado.geometry
                );

                const tagRestricaoAdd = `${indexGrupo}-${indexCamada}-restricao`;
                this.collapsesAbertos.push({
                    indexGrupo,
                    indexCamada,
                    tag: tagRestricaoAdd
                });

                this.mostrarAreasDiagnosticoNoMapa(tagRestricaoAdd, restricao);
            }
        },

        abrirModal(diagnosticoProtocolo) {
            this.mostrarDialogCamadas = true;
            this.layersMaps = [];
            this.areasRestricao = [];
            this.collapsesAbertos = [];
            this.diagnosticoSelecionado = null;

            diagnosticoProtocolo.grupo.forEach(grupo => {
                grupo.diagnostico.forEach(diagnostico => {
                    if (diagnostico.camada.nome === 'Áreas embargadas') {
                        diagnostico.camada.nome = 'Áreas embargadas (IBAMA)';
                    }
                });
            });
            this.diagnosticoSelecionado = diagnosticoProtocolo;

            this.adicionaGeometriasFixasNoMapa(diagnosticoProtocolo);
        },

        adicionaGeometriasFixasNoMapa(diagnosticoProtocolo) {
            if (diagnosticoProtocolo.territorioGeometria) {
                this.layersMaps.push({
                    style: getEstiloGeometria('area'),
                    geoJson: diagnosticoProtocolo.territorioGeometria,
                    name: 'territorio'
                });
            }

            if (diagnosticoProtocolo.glebaGeometria) {
                const idStyle = diagnosticoProtocolo.utilizouAreaTotalTerritorio
                    ? 'operacaoGlebaAreaTotalTerritorio'
                    : 'operacaoGleba';

                this.layersMaps.push({
                    style: getEstiloGeometria(idStyle),
                    geoJson: diagnosticoProtocolo.glebaGeometria,
                    name: idStyle
                });
            }

            if (diagnosticoProtocolo.proximidadeGeometria) {
                this.layersMaps.push({
                    style: getEstiloGeometria('area'),
                    geoJson: diagnosticoProtocolo.proximidadeGeometria,
                    name: 'proximidade'
                });
            }
        },

        abrirModalInibirRestricao(restricao, diagnostico) {
            this.restricao = restricao;

            if (!restricao.inibido) {
                this.inibicao.idRestricao = restricao.id;
                this.inibicao.codigoCamada = diagnostico.camada.codigo;
                this.inibicao.idOperacao = this.$route.params.id;
                this.$refs.modalInibirRestricao.mostrarDialog = true;
            } else {
                this.inibicao.idRestricao = restricao.id;
                this.inibicao.idOperacao = this.$route.params.id;
                this.$refs.modalJustificativaRestricao.mostrarDialog = true;
            }
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, restricao) {
            this.areasRestricao.forEach((area, index) => {
                let layerAreaDiagnostico;
                if (
                    restricao &&
                    restricao.index === index &&
                    restricao.overOrLeave === 'over'
                ) {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'orange',
                            weight: 1,
                            fill: true,
                            fillOpacity: 0.5
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        geoJson: area.geometria || area.geometry
                    };
                } else {
                    layerAreaDiagnostico = {
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            fillOpacity: 0.5
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        geoJson: area.geometria || area.geometry
                    };
                }

                this.layersMaps.push(layerAreaDiagnostico);
            });
        }
    }
};
</script>

<style lang="scss">
.resultado-diagnostico {
    .lista {
        display: flex;
        flex-direction: column;
        width: 35%;
        gap: 20px;
        max-height: 100vh;
        padding: 20px 10px 20px 20px;

        .lista__header {
            .voltar {
                cursor: pointer;
                margin-right: 10px;
            }

            h2 {
                color: var(--primary-font-color);
            }
        }

        .lista__content {
            display: flex;
            flex-direction: column;
            gap: 20px;
            height: 90vh;
            overflow-y: scroll;
        }

        .lista__grupo {
            label {
                color: var(--primary);
            }
        }
    }

    .mapa {
        width: 100%;
        height: 100vh;
        border-radius: 0;
    }

    .el-dialog__body {
        display: flex;
        padding: initial !important;
    }

    .el-dialog__header {
        padding: initial;
    }
}
</style>
